<div class="accordion-item">
  <h3 class="accordion-header" id="headingOne">
    <button class="accordion-button" type="button" data-bs-toggle="collapse" (click)="showDetails = !showDetails"
      [ngClass]="{'collapsed':!showDetails}" data-bs-target="#ProPD" aria-expanded="true" aria-controls="ProPD">
      <span>Provider Details</span>
      <div class="arrow"></div>
    </button>
  </h3>
  <div id="ProPD" class="accordion-collapse collapse " aria-labelledby="ProPD" [ngClass]="{'show':showDetails}"
    [formGroup]="provDetailsForm">
    <div class="accordion-body">

      <div class="row">
        <div class="col-3 mb-3">
          <label for="proName" class="form-label">Provider Name<span class="mandatory">*</span></label>
          <input autocomplete="disabled" type="text" id="proName" class="form-control" formControlName="name"
            [ngClass]="{'is-invalid' : submitted && provDetailsForm.controls['name'].errors?.['required']}"
            appPreventFirstSpace>
          <span *ngIf="submitted && provDetailsForm?.controls?.['name']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
        <div class="col-3 mb-3">
          <label for="proName" class="form-label">Provider Code<span class="mandatory">*</span></label>
          <input autocomplete="disabled" type="text" id="procode" class="form-control" formControlName="providerCode"
            [ngClass]="{'is-invalid' : submitted && provDetailsForm.controls['providerCode'].errors?.['required']}"
            appPreventFirstSpace>
          <span *ngIf="submitted && provDetailsForm?.controls?.['providerCode']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
        <div class="col-3 mb-3">
          <label for="ProType" class="form-label">Provider Type<span class="mandatory">*</span></label>
            <app-select-dropdown label="providerType" placeholder="Provider Type" [multiple]="true" [isClearable]="true"
              [options]="provType" [search]="true" id="id" class="dropdown-with-status" formControlName="type"
              [ngClass]="{'is-invalid':submitted && provDetailsForm.controls['type'].errors?.['required']}">
            </app-select-dropdown>
          <span *ngIf="submitted && provDetailsForm?.controls?.['type']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>

        <div class="col-3 mb-3">
          <label for="ProType" class="form-label">Speciality<span class="mandatory">*</span></label>
          <app-select-dropdown label="speciality" placeholder="Select" [multiple]="true" [isClearable]="true"
            [options]="specialityList" [search]="true" id="id" class="dropdown-with-status" formControlName="speciality"
            [ngClass]="{'is-invalid':submitted && provDetailsForm.controls['speciality'].errors?.['required']}">
          </app-select-dropdown>
          <span *ngIf="submitted && provDetailsForm?.controls?.['speciality']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>

        <div class="col-3 mb-3">
          <label for="proValidity" class="form-label">Validity<span class="mandatory">*</span></label>
          <div>
            <app-datepicker_v2 formControlName="validity" [field]="validity_date_v2" [disabled]="isEdit"
              [isInValid]="(submitted && provDetailsForm?.controls?.['validity']?.errors?.['required']) || 
                            (provDetailsForm?.controls?.['validity']?.errors?.['validityPattern']) || (provDetailsForm?.controls?.['validity']?.errors?.['checkEndDate']) || (provDetailsForm?.controls?.['validity']?.errors?.['checkStartDate'])">
            </app-datepicker_v2>
          </div>
          <span *ngIf="submitted && provDetailsForm?.controls?.['validity']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
          <span *ngIf="provDetailsForm?.controls?.['validity']?.errors?.['validityPattern']"
            class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
          <span *ngIf="provDetailsForm?.controls?.['validity']?.errors?.['checkEndDate']"
            class="invalid-feedback d-block" tabindex="0">{{EndDateError}}</span>
          <span *ngIf="provDetailsForm?.controls?.['validity']?.errors?.['checkStartDate']"
            class="invalid-feedback d-block" tabindex="0">{{startDateError}}</span>
        </div>
        <div class="col-3 mb-3">
          <label for="BCurrency" class="form-label">Billing Currency<span class="mandatory">*</span></label>
          <div
            [ngClass]="{'is-invalid' :submitted && (provDetailsForm?.controls?.['billingCurrency']?.errors?.['required'])}">
            <app-single-select uid="currencyId" [dataArr]="currencyList"
              (selectedEvent)="selectedValue($event,'billingCurrency');" label="currencyDesc"
              [selectedData]="provDetailsForm.value.billingCurrency" [placeholder]="'Select'">
            </app-single-select>
          </div>
          <span *ngIf="submitted && (provDetailsForm?.controls?.['billingCurrency']?.errors?.['required'])"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>

        <div class="col-3 mb-3">
          <label for="SCodeType" class="form-label">Service Code Type<span class="mandatory">*</span></label>
          <div
            [ngClass]="{'is-invalid' :submitted && (provDetailsForm?.controls?.['serviceType']?.errors?.['required'])}">

            <app-select-dropdown label="name" placeholder="Select" [multiple]="true" [isClearable]="true"
              [options]="dummyData" [search]="false" id="id" (change)="serviceCodeSelect($event)"
              class="dropdown-with-status" formControlName="serviceType"
              [ngClass]="{'is-invalid': submitted && (provDetailsForm?.controls?.['serviceType']?.errors?.['required'])}">
            </app-select-dropdown>
          </div>
          <span *ngIf="submitted && (provDetailsForm?.controls?.['serviceType']?.errors?.['required'])"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>



        <div class="col-3 mb-3">
          <div class="form-group">
            <label for="radio-button" class="form-label">Facility Type<span class="mandatory">*</span></label>
            <div class="radio-list  form-check-wrap">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="radio-buttonGovt" value="1"
                  formControlName="facilityType" name="radio-button">
                <label class="form-check-label" for="radio-buttonGovt">Government</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="radio-buttonPvt" value="0"
                  formControlName="facilityType" name="radio-button">
                <label class="form-check-label" for="radio-buttonPvt">Private</label>
              </div>
            </div>
            <span *ngIf="provDetailsForm?.controls?.['facilityType']?.errors?.['required'] && submitted"
              class="invalid-feedback d-block" tabindex="0">This field is required</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
